export default __webpack_public_path__ + "static/media/f1.7071fa05.jpg";